import React from 'react';

import { AdminPage } from '@/pages/AdminPage.tsx';
import { Queries } from '@/queries/Queries.ts';
import { PatientRouter, PractitionerRouter } from '@/router/Routers.tsx';

export const AppRouter: React.FC = () => {
  const me = Queries.user.useMe({});
  switch (me.userType) {
    case 'admin':
      return <AdminPage />;
    case 'patient':
      return <PatientRouter />;
    case 'practitioner':
      return <PractitionerRouter />;
  }
};
